<template>
  <div class="VariantManager">

    <h3 class="my-4">Automodelle</h3>
    <!-- Add Modal Forms -->
    <!-- Add Buttons -->
    <b-button-group class="mb-4">
      <b-button
        variant="outline-primary"
        v-on:click="addCarComponent('Manufacturer', 'Neuen Hersteller hinzufügen')">
      <i class="material-icons">add</i>Hersteller hinzufügen</b-button>

      <b-button
        variant="outline-primary"
        v-on:click="addCarComponent('Model', 'Neues Modell hinzufügen')">
      <i class="material-icons">add</i>Modell hinzufügen</b-button>

      <b-button
        variant="outline-primary"
        v-on:click="addCarComponent('Variant', 'Neues Baujahr hinzufügen')">
      <i class="material-icons">add</i>Baujahr hinzufügen</b-button>
    </b-button-group>

    <b-modal ref="modal-add" :title="addModal.title" hide-footer>
      <RwvEditManufacturer
        :slug="addModal.data.slug"
        v-if="addModal.componentToEdit == 'Manufacturer'"
        @close="closeModalAdd"
        :isModal="true"/>
      <RwvEditModel
        :slug="addModal.data.slug"
        :srcManufacturerSlug="addModal.data.manufacturerSlug"
        v-else-if="addModal.componentToEdit == 'Model'"
        @close="closeModalAdd"
        :isModal="true"/>
      <RwvEditVariant
        :slug="addModal.data.slug"
        :srcManufacturerSlug="addModal.data.model.manufacturerSlug"
        :srcModelSlug="addModal.data.modelSlug"
        v-else-if="addModal.componentToEdit == 'Variant'"
        @close="closeModalAdd"
        :isModal="true"/>
    </b-modal>

    <!-- Add Modal 'Are you sure?'' -->
    <b-modal
      ref="modal-are-you-sure"
      title="Wirklich löschen?"
      ok-title="Löschen"
      ok-variant="danger"
      @ok="deleteComponent(areYouSure.action, areYouSure.slug)"
      cancel-title="Abbrechen">
      <p class="my-4">{{areYouSure.text}}</p>
    </b-modal>

    <RwvVariantSelection @changedVariant="changedVariant" class="bg-light"></RwvVariantSelection>


    <p class="text-muted small">
      Zum Bearbeiten und Anzeigen der Modelle und Varianten.
    </p>

    <div v-if="!manufacturerSlug">
      <h3 class="my-4">Hersteller</h3>
      <b-card>
        <b-container class="bv-highlighted-row">
          <b-row class="whiteRow">
            <b-col align-self="center">
              Name
            </b-col>
            <b-col cols="4" md="2" sm="3">
            </b-col>
          </b-row>
          <b-row
            v-for="(manufacturer, index) in manufacturers"
            :key="manufacturer.slug"
            v-bind:class="{ whiteRow: index%2 }">
            <b-col>
              {{manufacturer.name}}
            </b-col>
            <b-col cols="4" md="2" sm="3">
              <b-button-group size="sm">
                <b-button
                  size="sm"
                  block
                  variant="outline-primary"
                  v-on:click="editCarComponent('Manufacturer', 'Hersteller bearbeiten', manufacturer)"
                  v-b-tooltip.hover
                  title="Hersteller bearbeiten">
                  <i class="material-icons">edit</i>
                </b-button>
                <b-button
                  block
                  size="sm"
                  variant="outline-danger"
                  v-on:click="deleteManufacturer(index)"
                  v-b-tooltip.hover
                  title="Hersteller entfernen">
                  <i class="material-icons">delete</i>
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </div>
    <div v-else-if="!modelSlug">
      <h3 class="my-4">Hersteller bearbeiten</h3>
      <RwvEditManufacturer
        :slug="manufacturerSlug"
        v-if="manufacturerSlug"
        :isModal="false"/>

      <!-- <div>
        <b-button
          block
          v-b-toggle.collapse-modells
          variant="outline-primary">
          Modellübersicht
        </b-button>
        <b-collapse id="collapse-modells" class="mt-2"> -->
      <h3 class="my-4">Modelle</h3>
        <b-card>
          <b-container class="bv-highlighted-row">
            <b-row class="whiteRow">
              <b-col align-self="center">
                Name
              </b-col>
              <b-col cols="4" md="2" sm="3">
              </b-col>
            </b-row>
            <b-row
              v-for="(model, index) in filteredModels"
              :key="model.slug"
              v-bind:class="{ whiteRow: index%2 }">
              <b-col>
                {{model.name}}
              </b-col>
              <b-col cols="4" md="2" sm="3">
                <b-button-group size="sm">
                  <b-button
                    size="sm"
                    block
                    variant="outline-primary"
                    v-on:click="editCarComponent('Model', 'Modell bearbeiten', model)"
                    v-b-tooltip.hover
                    title="Modell bearbeiten">
                    <i class="material-icons">edit</i>
                  </b-button>
                  <b-button
                    block
                    size="sm"
                    variant="outline-danger"
                    v-on:click="deleteModel(index)"
                    v-b-tooltip.hover
                    title="Modell entfernen">
                    <i class="material-icons">delete</i>
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
        <!-- </b-collapse>
      </div> -->
    </div>
    <div v-else-if="!variantSlug">
      <h3 class="my-4">Modell bearbeiten</h3>
      <RwvEditModel
        :slug="modelSlug"
        :srcManufacturerSlug="manufacturerSlug"
        v-if="modelSlug"
        :isModal="false"/>

      <!-- <div> -->
        <!-- <b-button
          block
          v-b-toggle.collapse-variants
          variant="outline-primary">
          Baujahrübersicht
        </b-button>
        <b-collapse id="collapse-variants" class="mt-2"> -->
      <h3 class="my-4">Varianten</h3>
      <b-card>
        <b-container class="bv-highlighted-row">
          <b-row class="whiteRow">
            <b-col align-self="center">
              Variante
            </b-col>
            <b-col align-self="center">
              Jahr
            </b-col>
            <b-col cols="4" md="2" sm="3">
            </b-col>
          </b-row>
          <b-row
            v-for="(variant, index) in filteredVariants"
            :key="variant.slug"
            v-bind:class="{ whiteRow: index%2 }">
            <b-col>
              {{variant.variant}}
            </b-col>
            <b-col>
              {{variant.year}}
            </b-col>
            <b-col cols="4" md="2" sm="3">
              <b-button-group size="sm">
                <b-button
                  size="sm"
                  block
                  variant="outline-primary"
                  v-on:click="editCarComponent('Variant', 'Variante bearbeiten', variant)"
                  v-b-tooltip.hover
                  title="Baujahr bearbeiten">
                  <i class="material-icons">edit</i>
                </b-button>
                <b-button
                  block
                  size="sm"
                  variant="outline-danger"
                  v-on:click="deleteVariant(index)"
                  v-b-tooltip.hover
                  title="Baujahr entfernen">
                  <i class="material-icons">delete</i>
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
        <!-- </b-collapse>
      </div> -->
    </div>
    <div v-else>
      <RwvEditVariant
        :slug="variantSlug"
        :srcManufacturerSlug="manufacturerSlug"
        :srcModelSlug="modelSlug"
        :isModal="false"/>
    </div>
    <!-- Case 1 nothing selected => List of Manufacturers -->
    <!-- Case 2 just manufacturer selected => Edit + List of Models -->
    <!-- Case 3 model selected => Edit + List of Variants -->
    <!-- Case 3 variant selected => Edit -->



    <!-- ToDo: Add List of Models -->
    <!-- <h3 class="my-4">Modelle</h3>
    <b-container class="bv-highlighted-row">
      <b-row>
        <b-col align-self="center">
          Name
        </b-col>
        <b-col cols="4" md="2" sm="3">
        </b-col>
      </b-row>
      <b-row v-for="(model, index) in models" :key="model.slug">
        <b-col>
          {{model.name}}
        </b-col>
        <b-col cols="4" md="2" sm="3">
          <b-button-group size="sm">
            <b-button
              size="sm"
              block
              variant="outline-primary"
              v-on:click="editCarComponent('Model', 'Modell bearbeiten', model)"
              v-b-tooltip.hover
              title="Hersteller bearbeiten">
              <i class="material-icons">edit</i>
            </b-button>
            <b-button
              block
              size="sm"
              variant="outline-danger"
              v-on:click="deleteManufacturer(index)"
              v-b-tooltip.hover
              title="Hersteller entfernen">
              <i class="material-icons">delete</i>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-container>

    <div v-for="variant in variants" :key="variant.slug">
      <p>
        {{variant}}
      </p>
    </div> -->

  </div>
</template>
<script>
import RwvEditVariant from '@/components/Admin/EditVariant.vue'
import RwvVariantSelection from '@/components/VariantSelection.vue'
import RwvEditModel from '@/components/Admin/EditModel.vue'
import RwvEditManufacturer from '@/components/Admin/EditManufacturer.vue'
import { mapGetters } from "vuex"
import {
  FETCH_MANUFACTURERS,
  FETCH_MODELS,
  FETCH_VARIANTS,
  MANUFACTURER_DELETE,
  MODEL_DELETE,
  VARIANT_DELETE
} from "@/store/actions.type";
export default {
  title: "Autos verwalten | So wird's gemacht",
  components: {
    RwvEditVariant,
    RwvEditModel,
    RwvEditManufacturer,
    RwvVariantSelection
  },
  data () {
    return {
      manufacturerSlug: "",
      modelSlug: "",
      variantSlug: "",
      addModal: {
        title: "",
        componentToEdit: "",
        data: {}
      },
      areYouSure: {
        text: "",
        action: "",
        slug: ""
      },
      manuModelFields: [{
          key:'name',
          label: 'Name',
          sortable: true
        },"actions"],
      variantFields: [{
          key:'year',
          label: 'Jahr',
          sortable: true
        },{
          key:'variant',
          label: 'Variante',
          sortable: true
        }]
    }
  },
  computed: {
    ...mapGetters(["manufacturers", "variants", "models"]),
    filteredModels() {
      var me = this
      if (me.manufacturerSlug) {
        return me.models.filter(function (model) {
          console.log("model")
          console.log(model)
          return me.manufacturerSlug == model.manufacturerSlug
        })
      } else {
        return []
      }
    },
    filteredVariants() {
      var me = this
      if (me.modelSlug) {
        return me.variants.filter(function (variant) {
          console.log("variant")
          console.log(variant)
          return me.modelSlug == variant.modelSlug
        })
      } else {
        return []
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    changedVariant(manufacturerSlug, modelSlug, variantSlug) {
      this.manufacturerSlug = manufacturerSlug
      this.modelSlug = modelSlug
      this.variantSlug = variantSlug
    },
    fetchManufacturers() {
      this.$store.dispatch(FETCH_MANUFACTURERS);
    },
    fetchModels(slug) {
      this.$store.dispatch(FETCH_MODELS);
    },
    fetchVariants(slug) {
      this.$store.dispatch(FETCH_VARIANTS);
    },
    addCarComponent(componentToEdit, title) {
      this.addModal.componentToEdit = componentToEdit
      this.addModal.title = title

      this.$refs['modal-add'].show()
    },
    editCarComponent(componentToEdit, title, data) {
      this.addModal.componentToEdit = componentToEdit
      this.addModal.title = title
      this.addModal.data = data

      this.$refs['modal-add'].show()
    },
    deleteManufacturer(index) {
      this.areYouSure.text = "Wollen sie wirklich den Hersteller " + this.manufacturers[index].name + " löschen? Warnung: Achten Sie darauf, dass keine Bücher und Modelle bereits assoziiert sind!"
      this.areYouSure.action = MANUFACTURER_DELETE
      this.areYouSure.slug = this.manufacturers[index].slug

      this.$refs['modal-are-you-sure'].show()
    },
    deleteModel(index) {
      var model = this.filteredModels[index]
      this.areYouSure.text = "Wollen sie wirklich das Modell " + model.name + " löschen? Warnung: Achten Sie darauf, dass keine Bücher und Baujahre bereits assoziiert sind!"
      this.areYouSure.action = MODEL_DELETE
      this.areYouSure.slug = model.slug

      this.$refs['modal-are-you-sure'].show()
    },
    deleteVariant(index) {
      var variant = this.filteredVariants[index]
      this.areYouSure.text = "Wollen sie wirklich das Baujahr " + variant.year + " (" + variant.variant + ") löschen? Warnung: Achten Sie darauf, dass keine Bücher bereits assoziiert sind!"
      this.areYouSure.action = VARIANT_DELETE
      this.areYouSure.slug = variant.slug

      this.$refs['modal-are-you-sure'].show()
    },
    deleteComponent(action, slug) {
      var me = this;
      me.$store
        .dispatch(action, slug)
        .then(({ data }) => {
          me.fetchData()
        })
        .catch(({ response }) => {
          console.log("Error")
          console.log(response)
        });
    },
    fetchData() {
      this.fetchManufacturers()
      this.fetchModels()
      this.fetchVariants()
    },
    closeModalAdd() {
      this.fetchData()
      this.$refs['modal-add'].hide()
    },
  }
}
</script>
<style lang="scss" scoped>
.bv-highlighted-row {
  .row>.col {
    padding: 10px 15px;
  }
  .row>.col, .row>.col-4 {
    border: 1px solid rgba(86,61,124,.2);
  }
  .row {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .row.whiteRow {
    background-color: rgba(0, 0, 0, 0.02);
  }
}
.RwvVariantSelection {
  padding: 20px;
}
</style>
